import classNames from 'classnames';
import React from 'react';

import {
  isGrid2xlBreakpoint,
  isGridBreakpoint,
  isGridDefBreakpoint,
  isGridLgBreakpoint,
  isGridMdBreakpoint,
  isGridSmBreakpoint,
  isGridXlBreakpoint,
} from '../grid-utils';
import { GridBreakpoints, GridClassName, GridCols, GridSpacing } from '../grid.types';

export const GRID_ROW_GAP_LOOKUP: { [key in GridSpacing]: GridClassName } = {
  0: 'gap-0',
  1: 'gap-1',
  2: 'gap-2',
  3: 'gap-3',
  4: 'gap-4',
  5: 'gap-5',
  6: 'gap-6',
  7: 'gap-7',
  8: 'gap-8',
  9: 'gap-9',
  10: 'gap-10',
  11: 'gap-11',
  12: 'gap-12',
};

export const GRID_ROW_SM_GAP_LOOKUP: { [key in GridSpacing]: GridClassName } = {
  0: 'sm:gap-0',
  1: 'sm:gap-1',
  2: 'sm:gap-2',
  3: 'sm:gap-3',
  4: 'sm:gap-4',
  5: 'sm:gap-5',
  6: 'sm:gap-6',
  7: 'sm:gap-7',
  8: 'sm:gap-8',
  9: 'sm:gap-9',
  10: 'sm:gap-10',
  11: 'sm:gap-11',
  12: 'sm:gap-12',
};

export const GRID_ROW_MD_GAP_LOOKUP: { [key in GridSpacing]: GridClassName } = {
  0: 'md:gap-0',
  1: 'md:gap-1',
  2: 'md:gap-2',
  3: 'md:gap-3',
  4: 'md:gap-4',
  5: 'md:gap-5',
  6: 'md:gap-6',
  7: 'md:gap-7',
  8: 'md:gap-8',
  9: 'md:gap-9',
  10: 'md:gap-10',
  11: 'md:gap-11',
  12: 'md:gap-12',
};

export const GRID_ROW_LG_GAP_LOOKUP: { [key in GridSpacing]: GridClassName } = {
  0: 'lg:gap-0',
  1: 'lg:gap-1',
  2: 'lg:gap-2',
  3: 'lg:gap-3',
  4: 'lg:gap-4',
  5: 'lg:gap-5',
  6: 'lg:gap-6',
  7: 'lg:gap-7',
  8: 'lg:gap-8',
  9: 'lg:gap-9',
  10: 'lg:gap-10',
  11: 'lg:gap-11',
  12: 'lg:gap-12',
};

export const GRID_ROW_XL_GAP_LOOKUP: { [key in GridSpacing]: GridClassName } = {
  0: 'xl:gap-0',
  1: 'xl:gap-1',
  2: 'xl:gap-2',
  3: 'xl:gap-3',
  4: 'xl:gap-4',
  5: 'xl:gap-5',
  6: 'xl:gap-6',
  7: 'xl:gap-7',
  8: 'xl:gap-8',
  9: 'xl:gap-9',
  10: 'xl:gap-10',
  11: 'xl:gap-11',
  12: 'xl:gap-12',
};

export const GRID_ROW_2XL_GAP_LOOKUP: { [key in GridSpacing]: GridClassName } = {
  0: '2xl:gap-0',
  1: '2xl:gap-1',
  2: '2xl:gap-2',
  3: '2xl:gap-3',
  4: '2xl:gap-4',
  5: '2xl:gap-5',
  6: '2xl:gap-6',
  7: '2xl:gap-7',
  8: '2xl:gap-8',
  9: '2xl:gap-9',
  10: '2xl:gap-10',
  11: '2xl:gap-11',
  12: '2xl:gap-12',
};

export const GRID_ROW_GAP_X_LOOKUP: { [key in GridSpacing]: GridClassName } = {
  0: 'gap-x-0',
  1: 'gap-x-1',
  2: 'gap-x-2',
  3: 'gap-x-3',
  4: 'gap-x-4',
  5: 'gap-x-5',
  6: 'gap-x-6',
  7: 'gap-x-7',
  8: 'gap-x-8',
  9: 'gap-x-9',
  10: 'gap-x-10',
  11: 'gap-x-11',
  12: 'gap-x-12',
};

export const GRID_ROW_SM_GAP_X_LOOKUP: { [key in GridSpacing]: GridClassName } = {
  0: 'sm:gap-x-0',
  1: 'sm:gap-x-1',
  2: 'sm:gap-x-2',
  3: 'sm:gap-x-3',
  4: 'sm:gap-x-4',
  5: 'sm:gap-x-5',
  6: 'sm:gap-x-6',
  7: 'sm:gap-x-7',
  8: 'sm:gap-x-8',
  9: 'sm:gap-x-9',
  10: 'sm:gap-x-10',
  11: 'sm:gap-x-11',
  12: 'sm:gap-x-12',
};

export const GRID_ROW_MD_GAP_X_LOOKUP: { [key in GridSpacing]: GridClassName } = {
  0: 'md:gap-x-0',
  1: 'md:gap-x-1',
  2: 'md:gap-x-2',
  3: 'md:gap-x-3',
  4: 'md:gap-x-4',
  5: 'md:gap-x-5',
  6: 'md:gap-x-6',
  7: 'md:gap-x-7',
  8: 'md:gap-x-8',
  9: 'md:gap-x-9',
  10: 'md:gap-x-10',
  11: 'md:gap-x-11',
  12: 'md:gap-x-12',
};

export const GRID_ROW_LG_GAP_X_LOOKUP: { [key in GridSpacing]: GridClassName } = {
  0: 'lg:gap-x-0',
  1: 'lg:gap-x-1',
  2: 'lg:gap-x-2',
  3: 'lg:gap-x-3',
  4: 'lg:gap-x-4',
  5: 'lg:gap-x-5',
  6: 'lg:gap-x-6',
  7: 'lg:gap-x-7',
  8: 'lg:gap-x-8',
  9: 'lg:gap-x-9',
  10: 'lg:gap-x-10',
  11: 'lg:gap-x-11',
  12: 'lg:gap-x-12',
};

export const GRID_ROW_XL_GAP_X_LOOKUP: { [key in GridSpacing]: GridClassName } = {
  0: 'xl:gap-x-0',
  1: 'xl:gap-x-1',
  2: 'xl:gap-x-2',
  3: 'xl:gap-x-3',
  4: 'xl:gap-x-4',
  5: 'xl:gap-x-5',
  6: 'xl:gap-x-6',
  7: 'xl:gap-x-7',
  8: 'xl:gap-x-8',
  9: 'xl:gap-x-9',
  10: 'xl:gap-x-10',
  11: 'xl:gap-x-11',
  12: 'xl:gap-x-12',
};

export const GRID_ROW_2XL_GAP_X_LOOKUP: { [key in GridSpacing]: GridClassName } = {
  0: '2xl:gap-x-0',
  1: '2xl:gap-x-1',
  2: '2xl:gap-x-2',
  3: '2xl:gap-x-3',
  4: '2xl:gap-x-4',
  5: '2xl:gap-x-5',
  6: '2xl:gap-x-6',
  7: '2xl:gap-x-7',
  8: '2xl:gap-x-8',
  9: '2xl:gap-x-9',
  10: '2xl:gap-x-10',
  11: '2xl:gap-x-11',
  12: '2xl:gap-x-12',
};

export const GRID_ROW_GAP_Y_LOOKUP: { [key in GridSpacing]: GridClassName } = {
  0: 'gap-y-0',
  1: 'gap-y-1',
  2: 'gap-y-2',
  3: 'gap-y-3',
  4: 'gap-y-4',
  5: 'gap-y-5',
  6: 'gap-y-6',
  7: 'gap-y-7',
  8: 'gap-y-8',
  9: 'gap-y-9',
  10: 'gap-y-10',
  11: 'gap-y-11',
  12: 'gap-y-12',
};

export const GRID_ROW_SM_GAP_Y_LOOKUP: { [key in GridSpacing]: GridClassName } = {
  0: 'sm:gap-y-0',
  1: 'sm:gap-y-1',
  2: 'sm:gap-y-2',
  3: 'sm:gap-y-3',
  4: 'sm:gap-y-4',
  5: 'sm:gap-y-5',
  6: 'sm:gap-y-6',
  7: 'sm:gap-y-7',
  8: 'sm:gap-y-8',
  9: 'sm:gap-y-9',
  10: 'sm:gap-y-10',
  11: 'sm:gap-y-11',
  12: 'sm:gap-y-12',
};

export const GRID_ROW_MD_GAP_Y_LOOKUP: { [key in GridSpacing]: GridClassName } = {
  0: 'md:gap-y-0',
  1: 'md:gap-y-1',
  2: 'md:gap-y-2',
  3: 'md:gap-y-3',
  4: 'md:gap-y-4',
  5: 'md:gap-y-5',
  6: 'md:gap-y-6',
  7: 'md:gap-y-7',
  8: 'md:gap-y-8',
  9: 'md:gap-y-9',
  10: 'md:gap-y-10',
  11: 'md:gap-y-11',
  12: 'md:gap-y-12',
};

export const GRID_ROW_LG_GAP_Y_LOOKUP: { [key in GridSpacing]: GridClassName } = {
  0: 'lg:gap-y-0',
  1: 'lg:gap-y-1',
  2: 'lg:gap-y-2',
  3: 'lg:gap-y-3',
  4: 'lg:gap-y-4',
  5: 'lg:gap-y-5',
  6: 'lg:gap-y-6',
  7: 'lg:gap-y-7',
  8: 'lg:gap-y-8',
  9: 'lg:gap-y-9',
  10: 'lg:gap-y-10',
  11: 'lg:gap-y-11',
  12: 'lg:gap-y-12',
};

export const GRID_ROW_XL_GAP_Y_LOOKUP: { [key in GridSpacing]: GridClassName } = {
  0: 'xl:gap-y-0',
  1: 'xl:gap-y-1',
  2: 'xl:gap-y-2',
  3: 'xl:gap-y-3',
  4: 'xl:gap-y-4',
  5: 'xl:gap-y-5',
  6: 'xl:gap-y-6',
  7: 'xl:gap-y-7',
  8: 'xl:gap-y-8',
  9: 'xl:gap-y-9',
  10: 'xl:gap-y-10',
  11: 'xl:gap-y-11',
  12: 'xl:gap-y-12',
};

export const GRID_ROW_2XL_GAP_Y_LOOKUP: { [key in GridSpacing]: GridClassName } = {
  0: '2xl:gap-y-0',
  1: '2xl:gap-y-1',
  2: '2xl:gap-y-2',
  3: '2xl:gap-y-3',
  4: '2xl:gap-y-4',
  5: '2xl:gap-y-5',
  6: '2xl:gap-y-6',
  7: '2xl:gap-y-7',
  8: '2xl:gap-y-8',
  9: '2xl:gap-y-9',
  10: '2xl:gap-y-10',
  11: '2xl:gap-y-11',
  12: '2xl:gap-y-12',
};

export const GRID_ROW_COLS_LOOKUP: { [key in GridCols]: GridClassName } = {
  none: 'grid-cols-none',
  1: 'grid-cols-1',
  2: 'grid-cols-2',
  3: 'grid-cols-3',
  4: 'grid-cols-4',
  5: 'grid-cols-5',
  6: 'grid-cols-6',
  7: 'grid-cols-7',
  8: 'grid-cols-8',
  9: 'grid-cols-9',
  10: 'grid-cols-10',
  11: 'grid-cols-11',
  12: 'grid-cols-12',
};

export const GRID_ROW_SM_COLS_LOOKUP: { [key in GridCols]: GridClassName } = {
  none: 'sm:grid-cols-none',
  1: 'sm:grid-cols-1',
  2: 'sm:grid-cols-2',
  3: 'sm:grid-cols-3',
  4: 'sm:grid-cols-4',
  5: 'sm:grid-cols-5',
  6: 'sm:grid-cols-6',
  7: 'sm:grid-cols-7',
  8: 'sm:grid-cols-8',
  9: 'sm:grid-cols-9',
  10: 'sm:grid-cols-10',
  11: 'sm:grid-cols-11',
  12: 'sm:grid-cols-12',
};

export const GRID_ROW_MD_COLS_LOOKUP: { [key in GridCols]: GridClassName } = {
  none: 'md:grid-cols-none',
  1: 'md:grid-cols-1',
  2: 'md:grid-cols-2',
  3: 'md:grid-cols-3',
  4: 'md:grid-cols-4',
  5: 'md:grid-cols-5',
  6: 'md:grid-cols-6',
  7: 'md:grid-cols-7',
  8: 'md:grid-cols-8',
  9: 'md:grid-cols-9',
  10: 'md:grid-cols-10',
  11: 'md:grid-cols-11',
  12: 'md:grid-cols-12',
};

export const GRID_ROW_LG_COLS_LOOKUP: { [key in GridCols]: GridClassName } = {
  none: 'lg:grid-cols-none',
  1: 'lg:grid-cols-1',
  2: 'lg:grid-cols-2',
  3: 'lg:grid-cols-3',
  4: 'lg:grid-cols-4',
  5: 'lg:grid-cols-5',
  6: 'lg:grid-cols-6',
  7: 'lg:grid-cols-7',
  8: 'lg:grid-cols-8',
  9: 'lg:grid-cols-9',
  10: 'lg:grid-cols-10',
  11: 'lg:grid-cols-11',
  12: 'lg:grid-cols-12',
};

export const GRID_ROW_XL_COLS_LOOKUP: { [key in GridCols]: GridClassName } = {
  none: 'xl:grid-cols-none',
  1: 'xl:grid-cols-1',
  2: 'xl:grid-cols-2',
  3: 'xl:grid-cols-3',
  4: 'xl:grid-cols-4',
  5: 'xl:grid-cols-5',
  6: 'xl:grid-cols-6',
  7: 'xl:grid-cols-7',
  8: 'xl:grid-cols-8',
  9: 'xl:grid-cols-9',
  10: 'xl:grid-cols-10',
  11: 'xl:grid-cols-11',
  12: 'xl:grid-cols-12',
};

export const GRID_ROW_2XL_COLS_LOOKUP: { [key in GridCols]: GridClassName } = {
  none: '2xl:grid-cols-none',
  1: '2xl:grid-cols-1',
  2: '2xl:grid-cols-2',
  3: '2xl:grid-cols-3',
  4: '2xl:grid-cols-4',
  5: '2xl:grid-cols-5',
  6: '2xl:grid-cols-6',
  7: '2xl:grid-cols-7',
  8: '2xl:grid-cols-8',
  9: '2xl:grid-cols-9',
  10: '2xl:grid-cols-10',
  11: '2xl:grid-cols-11',
  12: '2xl:grid-cols-12',
};

export interface GridRowProps {
  className?: string;
  cols?: GridCols | GridBreakpoints<GridCols>;
  spacing?: GridSpacing | GridBreakpoints<GridSpacing>;
  spacingX?: GridSpacing | GridBreakpoints<GridSpacing>;
  spacingY?: GridSpacing | GridBreakpoints<GridSpacing>;
}

export function GridRow(props: React.PropsWithChildren<GridRowProps>) {
  const { className, cols, spacing, spacingX, spacingY } = props;

  return (
    <ul
      className={classNames(
        'grid',

        // gap-*
        !isGridBreakpoint(spacing) && spacing ? GRID_ROW_GAP_LOOKUP[spacing] : undefined,
        isGridDefBreakpoint(spacing) ? GRID_ROW_GAP_LOOKUP[spacing.def] : undefined,
        isGridSmBreakpoint(spacing) ? GRID_ROW_SM_GAP_LOOKUP[spacing.sm] : undefined,
        isGridMdBreakpoint(spacing) ? GRID_ROW_MD_GAP_LOOKUP[spacing.md] : undefined,
        isGridLgBreakpoint(spacing) ? GRID_ROW_LG_GAP_LOOKUP[spacing.lg] : undefined,
        isGridXlBreakpoint(spacing) ? GRID_ROW_XL_GAP_LOOKUP[spacing.xl] : undefined,
        isGrid2xlBreakpoint(spacing) ? GRID_ROW_2XL_GAP_LOOKUP[spacing['2xl']] : undefined,

        // gap-x-*
        !isGridBreakpoint(spacingX) && spacingX ? GRID_ROW_GAP_X_LOOKUP[spacingX] : undefined,
        isGridDefBreakpoint(spacingX) ? GRID_ROW_GAP_X_LOOKUP[spacingX.def] : undefined,
        isGridSmBreakpoint(spacingX) ? GRID_ROW_SM_GAP_X_LOOKUP[spacingX.sm] : undefined,
        isGridMdBreakpoint(spacingX) ? GRID_ROW_MD_GAP_X_LOOKUP[spacingX.md] : undefined,
        isGridLgBreakpoint(spacingX) ? GRID_ROW_LG_GAP_X_LOOKUP[spacingX.lg] : undefined,
        isGridXlBreakpoint(spacingX) ? GRID_ROW_XL_GAP_X_LOOKUP[spacingX.xl] : undefined,
        isGrid2xlBreakpoint(spacingX) ? GRID_ROW_2XL_GAP_X_LOOKUP[spacingX['2xl']] : undefined,

        // gap-y-*
        !isGridBreakpoint(spacingY) && spacingY ? GRID_ROW_GAP_Y_LOOKUP[spacingY] : undefined,
        isGridDefBreakpoint(spacingY) ? GRID_ROW_GAP_Y_LOOKUP[spacingY.def] : undefined,
        isGridSmBreakpoint(spacingY) ? GRID_ROW_SM_GAP_Y_LOOKUP[spacingY.sm] : undefined,
        isGridMdBreakpoint(spacingY) ? GRID_ROW_MD_GAP_Y_LOOKUP[spacingY.md] : undefined,
        isGridLgBreakpoint(spacingY) ? GRID_ROW_LG_GAP_Y_LOOKUP[spacingY.lg] : undefined,
        isGridXlBreakpoint(spacingY) ? GRID_ROW_XL_GAP_Y_LOOKUP[spacingY.xl] : undefined,
        isGrid2xlBreakpoint(spacingY) ? GRID_ROW_2XL_GAP_Y_LOOKUP[spacingY['2xl']] : undefined,

        // grid-cols-*
        !isGridBreakpoint(cols) && cols ? GRID_ROW_COLS_LOOKUP[cols] : undefined,
        isGridDefBreakpoint(cols) ? GRID_ROW_COLS_LOOKUP[cols.def] : undefined,
        isGridSmBreakpoint(cols) ? GRID_ROW_SM_COLS_LOOKUP[cols.sm] : undefined,
        isGridMdBreakpoint(cols) ? GRID_ROW_MD_COLS_LOOKUP[cols.md] : undefined,
        isGridLgBreakpoint(cols) ? GRID_ROW_LG_COLS_LOOKUP[cols.lg] : undefined,
        isGridXlBreakpoint(cols) ? GRID_ROW_XL_COLS_LOOKUP[cols.xl] : undefined,
        isGrid2xlBreakpoint(cols) ? GRID_ROW_2XL_COLS_LOOKUP[cols['2xl']] : undefined,

        className
      )}
    >
      {props.children}
    </ul>
  );
}

export default GridRow;
